<template>
  <div>
    <transition name="slide">
      <b-row>
        <b-col cols="12" xl="12">
          <b-form>
            <b-card header="Filtro de Comprobantes">
              <b-form-group
                label="Desde"
                :label-cols="1"
                horizontal>
                <b-input-group>
                  <b-form-input 
                    v-model= "fechaDesde" 
                    type="date">
                  </b-form-input>
                </b-input-group>
              </b-form-group>

              <b-form-group
                label="Hasta"
                :label-cols="1"
                horizontal>
                <b-input-group>
                  <b-form-input 
                    v-model= "fechaHasta" 
                    type="date">
                  </b-form-input>
                </b-input-group>
              </b-form-group>

              <div slot="footer">
                <b-button size="sm" variant="primary" class="footer-button"
                  @click.prevent="emitirReporte">Emitir Reporte</b-button>
              </div>
            </b-card>
          </b-form>
        </b-col>
      </b-row>
    </transition>

    <b-modal title="SGC" 
        v-model="modalMsj" 
        header-bg-variant="light"
        ok-only 
        ok-variant="primary footer-button"
        @ok='okAction' @hidden="hiddenAction">
      {{ modalMensaje }}
    </b-modal>
  </div>
</template>

<script>
import moment from 'moment';

import { createHelpers } from 'vuex-map-fields';

export default {
  name: 'ReporteVentas',
  components: {},
  data: () => {
    return {
      modalMensaje: '',
      modalMsj: false,
      modalOkAction: null,
      modalHiddenAction: null,

      fechaDesde: new Date(),
      fechaHasta: new Date()
    }
  },
  created() {
    this.fechaDesde = moment(new Date()).add(-30, 'days').format('YYYY-MM-DD');
    this.fechaHasta = moment(new Date()).format('YYYY-MM-DD');
  },
  methods: {
    okAction(){
      if (this.modalOkAction) {
        this.modalOkAction();
      }
    },
    hiddenAction(){
      if (this.modalHiddenAction) {
        this.modalHiddenAction();
      }
    },
    emitirReporte() {
      let params= {
        fechaDesde: this.fechaDesde,
        fechaHasta: this.fechaHasta,
      }
      this.showSpinner();
      this.$store.dispatch('holistor/getReporteVentas', params)
        .then(() => {
          //console.log(this.$store.getters['holistor/ventas']);
          this.exportXLSHolistorVentas(this.$store.getters['holistor/ventas']);
        })
        .catch(error => {
          this.modalOkAction = null;
          this.modalHiddenAction = null;
          this.modalMensaje = error;
          this.modalMsj = true;
        })
        .finally(() => this.hideSpinner());
    },
  },
  watch: {
  }    
}
</script>

<style>
</style>
